/* Tidewater multi-variant collection quick order. Shopify cart is authoritative at checkout. */
(() => {
  'use strict';
  const rootPath = window.Shopify?.routes?.root || '/';
  const widgets = () => [...document.querySelectorAll('[data-twcq]')];
  const cartPath = rootPath + 'cart';
  const fetchCart = async () => {
    const response = await fetch(rootPath + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error('Unable to check your cart. Please refresh the page.');
    return response.json();
  };
  const countsFromCart = cart => {
    const counts = {};
    for(const item of cart.items) counts[String(item.variant_id)] = (counts[String(item.variant_id)] || 0) + item.quantity;
    return counts;
  };
  function boot(widget) {
    if(widget.dataset.twcqInitialized === 'yes') return;
    widget.dataset.twcqInitialized = 'yes';
    const rows=[...widget.querySelectorAll('[data-twcq-row]')];
    const button=widget.querySelector('.twcq__add');
    const pairs=widget.querySelector('.twcq__pairs');
    const total=widget.querySelector('.twcq__total');
    const message=widget.querySelector('.twcq__message');
    let counts={}, ready=false, busy=false;
    const money = cents => {
      try { return new Intl.NumberFormat(widget.dataset.locale || 'en-US', {style:'currency',currency:widget.dataset.currency || 'USD'}).format(cents/100); }
      catch { return '$'+(cents/100).toFixed(2); }
    };
    const min = row => Math.max(1,Number(row.dataset.min)||1);
    const step = row => Math.max(1,Number(row.dataset.step)||1);
    const already = row => counts[String(row.dataset.id)]||0;
    const limit = row => {
      let max=Infinity;
      if(row.dataset.tracked==='true' && row.dataset.backorder!=='true') max=Math.max(0,Number(row.dataset.stock)-already(row));
      if(Number(row.dataset.max)>0) max=Math.min(max,Math.max(0,Number(row.dataset.max)-already(row)));
      return max;
    };
    function normalize(row, requested) {
      let value=Math.max(0,Math.floor(Number(requested)||0));
      if(value===0 || limit(row)<min(row)) return 0;
      value=min(row)+Math.ceil(Math.max(0,value-min(row))/step(row))*step(row);
      if(value>limit(row)) value=min(row)+Math.floor((limit(row)-min(row))/step(row))*step(row);
      return Math.max(0,value);
    }
    const alert = (msg, success=false) => {
      message.textContent=msg;
      message.hidden=!msg;
      message.classList.toggle('twcq__message--success',success);
      message.classList.toggle('twcq__message--error',!success);
    };
    function update() {
      let qty=0, subtotal=0;
      for(const row of rows) {
        const input=row.querySelector('.twcq__input');
        if(!input) continue;
        const n=Number(input.value)||0;
        qty+=n; subtotal+=n*Number(row.dataset.price);
        input.disabled=!ready || busy || limit(row)<min(row);
        row.querySelector('.twcq__minus').disabled=!ready || busy || n===0;
        row.querySelector('.twcq__plus').disabled=!ready || busy || (n===0 ? limit(row)<min(row) : n+step(row)>limit(row));
      }
      pairs.textContent=qty;
      total.textContent=money(subtotal);
      button.disabled=!ready || busy || qty===0;
      if(!busy) button.textContent=qty ? `ADD ${qty} TO CART` : 'ADD TO CART';
    }
    for(const row of rows) {
      const input=row.querySelector('.twcq__input');
      if(!input) continue;
      row.querySelector('.twcq__plus').addEventListener('click',()=>{
        input.value=normalize(row,Number(input.value)===0 ? min(row):Number(input.value)+step(row));
        alert(''); update();
      });
      row.querySelector('.twcq__minus').addEventListener('click',()=>{
        input.value=Number(input.value)<=min(row)?0:normalize(row,Number(input.value)-step(row));
        alert(''); update();
      });
      input.addEventListener('change',()=>{
        const old=Number(input.value)||0;
        input.value=normalize(row,old);
        alert(Number(input.value)!==old?'Quantity adjusted to the available amount.':'');
        update();
      });
    }
    async function syncCart() {
      const cart=await fetchCart(); counts=countsFromCart(cart); ready=true;
      for(const row of rows){const input=row.querySelector('.twcq__input');if(input)input.value=normalize(row,input.value);}
      update(); return cart;
    }
    button.addEventListener('click',async()=>{
      if(busy || !ready) return;
      busy=true;button.textContent='ADDING...'; update(); alert('');
      try {
        // Keep the requested quantities for comparison before applying revised cart limits.
        const requested=rows.map(row=>Number(row.querySelector('.twcq__input')?.value)||0);
        const cart=await fetchCart(); counts=countsFromCart(cart);
        let changed=false;
        const items=[];
        rows.forEach((row,index)=>{
          const input=row.querySelector('.twcq__input'); if(!input)return;
          const qty=normalize(row,requested[index]);
          if(qty!==requested[index])changed=true;
          input.value=qty;
          if(qty)items.push({id:Number(row.dataset.id),quantity:qty});
        });
        if(changed) throw new Error('Inventory or cart quantities changed. Please review the adjusted quantities and try again.');
        if(!items.length) throw new Error('Please select at least one available size.');
        const response=await fetch(rootPath+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result=await response.json();
        if(!response.ok) throw new Error(result.description || 'Unable to add the selected items.');
        rows.forEach(row=>{const input=row.querySelector('.twcq__input');if(input)input.value=0;});
        // New cart totals available to consumers and custom integrations.
        const updated=await fetchCart();counts=countsFromCart(updated);
        document.dispatchEvent(new CustomEvent('tw:cart-updated',{detail:{cart:updated}}));
        alert('Added to cart. Continue shopping or view your cart.',true);
        let link=message.querySelector('a');
        if(!link){link=document.createElement('a');link.href=cartPath;link.textContent=' View cart';link.style.textDecoration='underline';message.appendChild(link);}
      } catch(e){alert(e.message || 'Unable to add items. Please try again.');}
      finally{busy=false;update();}
    });
    update();
    syncCart().catch(e=>{ready=false;alert(e.message);update();});
    // Recheck quantities when returning to a previously open collection tab.
    window.addEventListener('pageshow',()=>{if(!busy)syncCart().catch(()=>{});},{passive:true});
  }
  function initialize(){ widgets().forEach(boot); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initialize);
  else initialize();
  document.addEventListener('shopify:section:load',initialize);
  let timer;
  new MutationObserver(mutations=>{
    if(!mutations.some(m=>[...m.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('[data-twcq]')||n.querySelector?.('[data-twcq]')))))return;
    clearTimeout(timer);timer=setTimeout(initialize,50);
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
